import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as CheckmarkIcon } from "../../assets/icons/checkmark-new.svg";
import { markWelcomeShown } from "../../store/clubChecklistSlice";
import { AppDispatch } from "../../store";
import { CHECKLIST_TOTAL_COUNT } from "../../utils/checklist";

const WelcomeScreen = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);

  const handleLetsGo = async () => {
    setLoading(true);
    await dispatch(markWelcomeShown());
    setLoading(false);
  };

  return (
    <div className="bg-white border border-eai-accent-lt rounded-md p-5 mb-6">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-eai-primary-accent flex items-center justify-center flex-shrink-0">
          <CheckmarkIcon className="w-5 h-5" style={{ "--stroke-0": "white" } as any} />
        </div>
        <div>
          <h2 className="text-base font-bold text-gray-900 font-Inter">
            Earn a free hat!
          </h2>
          <p className="text-sm text-gray-500 font-Inter">
            Complete {CHECKLIST_TOTAL_COUNT} steps to claim yours
          </p>
        </div>
      </div>
      <p className="text-sm text-gray-600 leading-relaxed mb-4 font-Inter">
        Work through these steps at your own pace to get the most out of the
        platform — and earn a free hat on us when you're done.
      </p>
      <button
        onClick={handleLetsGo}
        disabled={loading}
        className="w-full eai-btn-grn text-sm font-Inter disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {loading ? "Loading..." : "Let's go"}
      </button>
    </div>
  );
};

export default WelcomeScreen;
